import en from './en'
import fr from './fr'
export default {
    en: en,
    fr: fr
}



// WEBPACK FOOTER //
// ./src/i18n/i18n.js